import { useCallback } from 'react';

import { ADOBE_DATA_LAYER, TRACKING_EVENT_TYPE } from '@utilities/constants';

const useAdobeTracking = () => {
  const sendAdobeEvent = (event: unknown) => {
    window[ADOBE_DATA_LAYER].push(event);
  };

  const trackEvent = useCallback(
    (
      title: string,
      name: string,
      details?: unknown,
      type: string = TRACKING_EVENT_TYPE.CLICK_EVENT,
    ) => {
      sendAdobeEvent({
        event: title,
        interaction: {
          type,
          name,
          details,
        },
      });
    },
    [],
  );

  return { trackEvent, sendAdobeEvent };
};

export default useAdobeTracking;
